// client/src/routes/app/fiscal/declarations.$declarationId/index.tsx — SCR-FISC-003 · FISC-007.
//
// The D212 preview and, for a C168 obligation, the package the same route serves — one
// generation route answers both forms (D-1258), so one detail screen renders whichever the
// declaration carries.
//
// The guards are the branch's (`route.tsx`); this file is the screen.

import { createFileRoute } from '@tanstack/react-router';

import { DeclarationScreen } from '@/features/fiscal/DeclarationScreen';

export const Route = createFileRoute('/app/fiscal/declarations/$declarationId/')({
  component: DeclarationRoute,
});

function DeclarationRoute() {
  const { declarationId } = Route.useParams();
  return <DeclarationScreen declarationId={declarationId} />;
}
